import Link from "next/link";
import Image from "next/image";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";
import DefaultLogo from "./defaultLogo.svg";

interface MerchantLogoProps {
  merchantLogo?: string;
  showLink: boolean;
  linkHref: string | object;
}

export const MerchantLogo = ({
  merchantLogo = DefaultLogo.src,
  showLink,
  linkHref,
}: MerchantLogoProps) => {
  const image = (
    <Image
      data-testid={applyDataTestId(pom.header.merchantLogoDataTestId)}
      className="sm:block h-[51px] w-[51px] sm:h-16 sm:w-16"
      src={merchantLogo}
      alt={pom.header.merchantLogo}
      width={100}
      height={100}
    />
  );

  if (showLink) {
    return <Link href={linkHref}>{image}</Link>;
  }

  return image;
};
